/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Subject } from 'rxjs';
import { StoreItemFilterInfo } from '../model/storeitemfilterinfo';

export class StoreFilterService {
    private subjectForFilterInfo = new Subject<StoreItemFilterInfo>();
    private subjectForSearchTerm = new Subject<StoreItemFilterInfo>();

    applyFilter(filter: StoreItemFilterInfo) {
        this.subjectForFilterInfo.next(filter);
    }

    getFilter(): Subject<StoreItemFilterInfo> {
        return this.subjectForFilterInfo;
    }

    applySearchFilter(filter: StoreItemFilterInfo) {
        this.subjectForSearchTerm.next(filter);
    }

    getSearchFilter(): Subject<StoreItemFilterInfo> {
        return this.subjectForSearchTerm;
    }
}
